/**
 * Which printed code brought this person here.
 *
 * A code on a poster adds `?src=ABC1234` to the address it opens. The visitor
 * then taps through two or three pages before they fill anything in, and the
 * query string is long gone by then — so it is kept for the length of the visit
 * and attached to whatever they eventually submit.
 *
 * Session storage, not a cookie: it is gone when the tab closes, it is never
 * sent to anybody else's server, and it identifies a poster rather than a
 * person. The code is checked against the register on the way in, so a made-up
 * one is simply not recorded.
 */
const KEY = 'fwm_qr_src';

export const captureSource = () => {
  try {
    const src = new URLSearchParams(window.location.search).get('src');
    if (src && /^[A-Z0-9]{4,16}$/i.test(src)) {
      sessionStorage.setItem(KEY, src.toUpperCase());
      return src.toUpperCase();
    }
    return sessionStorage.getItem(KEY) || '';
  } catch {
    return '';
  }
};

export const getSource = () => {
  try {
    return sessionStorage.getItem(KEY) || '';
  } catch {
    return '';
  }
};

export default getSource;
